export const m8l1Solution = `%lang starknet

from starkware.cairo.common.math_cmp import is_not_zero
from starkware.cairo.common.bool import TRUE, FALSE

// Sometimes, conditionals can be avoided by using a polynomial that maps valid inputs to 0
// Use this trick to rewrite functions without "if"

// TODO: Implement a ternary operator 'if cond then return val_true else return val_false'
// Make sure the condition is a boolean
// do not modify code on this line or above

func if_then_else(cond : felt, val_true : felt, val_false) -> (res : felt) {
    let is_boolean_helper = (cond - TRUE) * (cond - FALSE);
    assert 0 = is_boolean_helper;

    let res = cond * val_true + (1 - cond) * val_false;
    return (res=res);
}

// do not modify code on this line or below

@external
func test_ternary_conditional_operator() {
    let (res) = if_then_else(FALSE, 911, 420);
    assert 420 = res;
    let (res) = if_then_else(TRUE, 911, 'over 9000');
    assert 911 = res;
    let (res) = if_then_else(FALSE, 69420, 1559);
    assert 1559 = res;
    let (res) = if_then_else(TRUE, 'nice', 69);
    assert 'nice' = res;
    %{ expect_revert() %}
    let (res) = if_then_else(69, 'nope', 911);
    return ();
}`;
